var cov_14jkxev2ey = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Modal/styles/index.js",
      hash = "71f8790562729c0265306ab0b33ebcca77ff2196",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Modal/styles/index.js",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 26
        },
        end: {
          line: 5,
          column: 56
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var modalLess = {};
import genaration from '../../utils/classname';
export var modalClass = (cov_14jkxev2ey.s[0]++, genaration(modalLess, 'modal'));